import { render } from "./ProjectListItem.vue?vue&type=template&id=fb583bb6&scoped=true"
import script from "./ProjectListItem.vue?vue&type=script&lang=js"
export * from "./ProjectListItem.vue?vue&type=script&lang=js"

import "./ProjectListItem.vue?vue&type=style&index=0&id=fb583bb6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb583bb6"]])

export default __exports__